import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";

export const pushStatsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getApiUrl: () => apiUrl,

    custom: async ({ method, meta, url }) => {
      if (method?.toLowerCase() !== "get") {
        return Promise.reject({ message: "Method not implemented" });
      }

      try {
        const requestUrl =
          url === "user-status" ? "cms/push/user-status" : "cms/push/analytics";
        const { data } = await httpClient.get(requestUrl, {
          params: meta?.params,
        });

        return {
          data,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },

    getList: async () => {
      try {
        const { data } = await httpClient.get("/cms/pushlogs/stats/get");

        return {
          data,
          total: data.length,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },

    getOne: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },

    create: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },

    update: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },

    deleteOne: async () => {
      return Promise.reject({ message: "Method not implemented" });
    },
  };
